"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSectionValueForTracking = exports.VISIBLE_SECTIONS = exports.getTimestepLabel = exports.checkIfSelectedReportTableCellEquals = exports.checkIfSelectedCategoryEquals = exports.isOverTimeOptions = exports.IntervalFilterOptions = exports.IncomeVsExpenseBreakdownTypes = exports.generateDownloadFile = exports.getDownloadFormats = exports.downloadableFileTypes = exports.generateFilterText = exports.getIncomeExpenseTableStructuredData = exports.generateTotalRowData = exports.normalizeCategoryData = exports.indentedGroupKey = exports.getChartIconTipLabel = exports.findGroupByCategoryId = exports.getSelectedIncomeExpenseReportCellTxns = exports.getDefaultIsOverTimeFromTabName = exports.getDefaultGroupByFromTabName = exports.convertTabValueToName = exports.convertTabNameToTitle = exports.convertTabNameToValue = exports.getFilterOptionsFromTabName = exports.ChartTypes = exports.Tabs = void 0;
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const jspdf_1 = require("jspdf");
const jspdf_autotable_1 = require("jspdf-autotable");
const write_excel_file_1 = __importDefault(require("write-excel-file"));
const retrievers_1 = require("data/accounts/retrievers");
const transactions_1 = require("companion-app-components/flux/transactions");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const AmountField_1 = require("components/QuickenControls/AmountField");
const utils_1 = require("utils/utils");
// Static colors for PDF export — intentionally not theme-dependent
const PDF_COLORS = {
    cellBackground: '#ffffff',
    cellText: '#333333',
    sectionBackground: '#f5f5f5',
    mutedText: '#81929b', // icon.muted
};
const CURRENCY_FORMAT = '0,00.00';
const SPLIT_STRING = '--- Split ---';
const DASH_STRING = '---';
const MAX_PDF_PERIOD_COLUMNS = 6;
const DATE_FORMAT = 'M/d/yy';
exports.Tabs = {
    SPENDING: 'spending',
    NET_INCOME: 'net-income',
    INCOME_VS_SPENDING: 'income-vs-spending',
    ITEMIZED_TRANSACTIONS: 'itemized',
};
exports.ChartTypes = {
    BAR: 'bar',
    GROUPED_BAR: 'grouped bar',
    STACKED_BAR: 'stacked bar',
    PIE: 'pie',
    MULTILINE: 'multiline',
    SIDEWAYS_BAR: 'sideways bar',
    INCOME_VS_SPENDING: 'income vs spending',
};
function getFilterOptionsFromTabName(tabName) {
    switch (tabName) {
        case exports.Tabs.SPENDING:
            return [
                { label: 'By category', value: 'category', id: 'breakdown_by_category' },
                { label: 'By payee', value: 'payee', id: 'breakdown_by_payee' },
                // { label: 'By tag', value: 'tag', id: 'breakdown_by_tag' },
                { label: 'None', value: 'none', id: 'breakdown_by_none' },
            ];
        case exports.Tabs.NET_INCOME:
        case exports.Tabs.INCOME_VS_SPENDING:
        default:
            return null;
    }
}
exports.getFilterOptionsFromTabName = getFilterOptionsFromTabName;
function convertTabNameToValue(tabName) {
    switch (tabName) {
        case exports.Tabs.SPENDING:
            return 0;
        case exports.Tabs.NET_INCOME:
            return 1;
        case exports.Tabs.INCOME_VS_SPENDING:
            return 2;
        case exports.Tabs.ITEMIZED_TRANSACTIONS:
            return 3;
        default:
            return 0;
    }
}
exports.convertTabNameToValue = convertTabNameToValue;
function convertTabNameToTitle(tabName) {
    switch (tabName) {
        case exports.Tabs.SPENDING:
            return 'Reports: Spending';
        case exports.Tabs.NET_INCOME:
            return 'Reports: Net Income';
        case exports.Tabs.INCOME_VS_SPENDING:
            return 'Reports: Income VS. Expense';
        case exports.Tabs.ITEMIZED_TRANSACTIONS:
            return 'Reports: Itemized Transactions';
        default:
            return 'Reports';
    }
}
exports.convertTabNameToTitle = convertTabNameToTitle;
function convertTabValueToName(tabValue) {
    switch (tabValue) {
        case 0:
            return exports.Tabs.SPENDING;
        case 1:
            return exports.Tabs.NET_INCOME;
        case 2:
            return exports.Tabs.INCOME_VS_SPENDING;
        case 3:
            return exports.Tabs.ITEMIZED_TRANSACTIONS;
        default:
            return exports.Tabs.SPENDING;
    }
}
exports.convertTabValueToName = convertTabValueToName;
const tabNameToGroupBy = {
    spending: 'category',
    [exports.Tabs.ITEMIZED_TRANSACTIONS]: 'category',
};
function getDefaultGroupByFromTabName(tabName) {
    return tabNameToGroupBy[tabName] || null;
}
exports.getDefaultGroupByFromTabName = getDefaultGroupByFromTabName;
const tabNameToIsOverTime = {
    [exports.Tabs.SPENDING]: false,
    [exports.Tabs.NET_INCOME]: true,
    [exports.Tabs.INCOME_VS_SPENDING]: true,
    [exports.Tabs.ITEMIZED_TRANSACTIONS]: false,
};
function getDefaultIsOverTimeFromTabName(tabName) {
    return tabNameToIsOverTime[tabName];
}
exports.getDefaultIsOverTimeFromTabName = getDefaultIsOverTimeFromTabName;
// Restores the selected register slice from the latest income/expense report rows after refresh.
const getSelectedIncomeExpenseReportCellTxns = (selectedCell, incomeRows = [], expenseRows = []) => {
    var _a, _b, _c, _d, _e;
    if (!selectedCell) {
        return null;
    }
    const reportRows = (() => {
        if (selectedCell.section === 'income') {
            return incomeRows;
        }
        if (selectedCell.section === 'expense') {
            return expenseRows;
        }
        return [...incomeRows, ...expenseRows];
    })();
    const selectedRowById = selectedCell.rowId
        ? reportRows.find((row) => (row.rowId || row.categoryId) === selectedCell.rowId)
        : null;
    const isPayeeRow = ((_a = selectedCell.rowId) === null || _a === void 0 ? void 0 : _a.startsWith('income-')) || ((_b = selectedCell.rowId) === null || _b === void 0 ? void 0 : _b.startsWith('expense-'));
    let selectedRow = selectedRowById;
    if (!selectedRow && selectedCell.groupKey) {
        if (!selectedCell.rowId) {
            selectedRow = reportRows.find((row) => row.groupKey === selectedCell.groupKey);
        }
        else if (isPayeeRow) {
            const selectedRowSection = selectedCell.rowId.startsWith('income-') ? 'income' : 'expense';
            const matchingRows = reportRows.filter((row) => row.groupKey === selectedCell.groupKey);
            const sortedRows = matchingRows.sort((firstRow, secondRow) => {
                var _a, _b, _c, _d;
                const firstInOriginalSection = ((_b = (_a = firstRow.rowId) === null || _a === void 0 ? void 0 : _a.startsWith) === null || _b === void 0 ? void 0 : _b.call(_a, `${selectedRowSection}-`)) ? 0 : 1;
                const secondInOriginalSection = ((_d = (_c = secondRow.rowId) === null || _c === void 0 ? void 0 : _c.startsWith) === null || _d === void 0 ? void 0 : _d.call(_c, `${selectedRowSection}-`)) ? 0 : 1;
                return firstInOriginalSection - secondInOriginalSection;
            });
            selectedRow = sortedRows.find((row) => {
                var _a;
                return (_a = row.periods) === null || _a === void 0 ? void 0 : _a.some((period) => selectedCell.periodKey ? period.timeStamp === selectedCell.periodKey : period.category === selectedCell.category);
            });
        }
    }
    const selectedPeriod = selectedCell.periodKey
        ? (_c = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.periods) === null || _c === void 0 ? void 0 : _c.find((period) => period.timeStamp === selectedCell.periodKey)
        : (_d = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.periods) === null || _d === void 0 ? void 0 : _d.find((period) => period.category === selectedCell.category);
    return (_e = selectedPeriod === null || selectedPeriod === void 0 ? void 0 : selectedPeriod.txns) !== null && _e !== void 0 ? _e : (0, immutable_1.List)();
};
exports.getSelectedIncomeExpenseReportCellTxns = getSelectedIncomeExpenseReportCellTxns;
// searches through the groups object to find a group with a specific category Id
// also builds the breadcrumbs to the group
// TODO: clean this guy up
function findGroupByCategoryId(catId, group, crumbs = []) {
    var _a;
    if (!group)
        return [null, crumbs];
    if (catId === 'EverythingElse' && (group === null || group === void 0 ? void 0 : group.groupKey) === 'Everything else') {
        return [group, crumbs.concat([{ name: group === null || group === void 0 ? void 0 : group.groupKey, categoryId: group.categoryId, total: group.total }])];
    }
    if (group.categoryId === catId)
        return [group, crumbs];
    let groupFound = null;
    let crumbsFound = crumbs;
    (_a = group.subgroups) === null || _a === void 0 ? void 0 : _a.some((subG) => {
        [groupFound, crumbsFound] = findGroupByCategoryId(catId, subG, crumbs.concat([{ name: subG === null || subG === void 0 ? void 0 : subG.groupKey, categoryId: subG.categoryId, total: subG.total }]));
        return groupFound; // will cause .some() to short circuit when the group is found recurseively
    });
    return [groupFound, crumbsFound];
}
exports.findGroupByCategoryId = findGroupByCategoryId;
const getChartIconTipLabel = (chartType) => {
    let label;
    switch (chartType) {
        case exports.ChartTypes.STACKED_BAR:
            label = 'Stack';
            break;
        case exports.ChartTypes.GROUPED_BAR:
        case exports.ChartTypes.INCOME_VS_SPENDING:
            label = 'Cluster';
            break;
        case exports.ChartTypes.SIDEWAYS_BAR:
            label = 'Bar';
            break;
        case exports.ChartTypes.PIE:
            label = 'Pie';
            break;
        default:
            label = '';
    }
    return label;
};
exports.getChartIconTipLabel = getChartIconTipLabel;
const generateHyphens = (number) => '-'.repeat(number);
const tableDSForPdf = (payee, date, accountName, category, amount, type, isGroupKeyEqualsParentGroupKey, isParent, level, currency) => ({
    payee,
    date,
    accountName,
    category,
    amount: (0, AmountField_1.formatNumber)(amount, currency, CURRENCY_FORMAT),
    type,
    level: isGroupKeyEqualsParentGroupKey ? level : Number(level) + 1,
    isParent,
});
const constructPdfColumns = (groupBy, isNotSpendingTab) => {
    let columns = [];
    if (isNotSpendingTab) {
        columns = [
            { header: 'Date', dataKey: 'date' },
            { header: 'Payee', dataKey: 'payee' },
            { header: 'Category', dataKey: 'category' },
            { header: 'Account', dataKey: 'accountName' },
            { header: 'Amount', dataKey: 'amount' },
        ];
    }
    else {
        columns = [
            { header: groupBy === 'category' ? 'Category' : 'Payee', dataKey: 'payee' },
            { header: 'Date', dataKey: 'date' },
            { header: 'Account', dataKey: 'accountName' },
            { header: groupBy === 'category' ? 'Payee' : 'Category', dataKey: 'category' },
            { header: 'Amount', dataKey: 'amount' },
        ];
    }
    return columns;
};
const cellStylingForPdfTable = (row, cell, tabName) => {
    // Table Cell spacing, borders and aligments
    /* eslint-disable no-param-reassign */
    const sectionLineStyle = (lineWidth) => {
        cell.styles.fillColor = PDF_COLORS.cellBackground;
        cell.styles.lineColor = PDF_COLORS.cellText;
        cell.styles.lineWidth = lineWidth;
    };
    const { raw, cells } = row;
    if (row.section === 'body') {
        cell.styles.textColor = PDF_COLORS.cellText;
        cells[2].styles.cellPadding = { right: 15, top: 10 };
        if (raw.type === 'group') {
            sectionLineStyle({ bottom: 0.1 });
            cell.styles.cellPadding = { top: 10 };
        }
        else if (raw.type === 'groupType') {
            cell.styles.fillColor = PDF_COLORS.sectionBackground;
            cell.styles.lineColor = PDF_COLORS.cellText;
            cell.styles.cellPadding = { left: 0, right: 0, top: 5, bottom: 5 };
            cells[4].styles.halign = 'right';
        }
        else if (raw.type === 'txn') {
            cell.styles.cellPadding = { top: 10 };
            if (tabName !== exports.Tabs.NET_INCOME && tabName !== exports.Tabs.INCOME_VS_SPENDING) {
                cells[0].styles.cellPadding = { left: ((raw === null || raw === void 0 ? void 0 : raw.level) || 0) * 20, top: 10 };
            }
        }
        else if (raw.type === 'total') {
            cell.styles.fontStyle = 'bold';
            cell.styles.cellPadding = { top: 15 };
            sectionLineStyle({ top: 0.1 });
        }
    }
    else if (row.section === 'head') {
        sectionLineStyle({ bottom: 0.1 });
        cell.styles.textColor = PDF_COLORS.cellText;
        cell.styles.cellPadding = { left: 0, right: 0 };
        cells[4].styles.halign = 'right';
    }
};
const indentedGroupKey = (indentation, groupKey) => `${'-'.repeat(indentation - 1)}${groupKey}`;
exports.indentedGroupKey = indentedGroupKey;
const normalizeCategoryData = (periods) => periods.reduce((acc, period) => {
    acc[period.category] = period;
    return acc;
}, {});
exports.normalizeCategoryData = normalizeCategoryData;
const generateTotalRowData = (chartData) => {
    const totalIncomeRowData = {};
    const totalExpenseRowData = {};
    const overallTotalIncomeRowData = {};
    chartData.forEach(({ category, incomeTotalForReport, spendingTotalForReport, netIncomeTotal }) => {
        totalIncomeRowData[category] = {
            totalOfCategory: (0, AmountField_1.formatNumber)(incomeTotalForReport, '', CURRENCY_FORMAT),
        };
        totalExpenseRowData[category] = {
            totalOfCategory: (0, AmountField_1.formatNumber)(spendingTotalForReport * -1, '', CURRENCY_FORMAT),
        };
        overallTotalIncomeRowData[category] = {
            totalOfCategory: (0, AmountField_1.formatNumber)(netIncomeTotal, '', CURRENCY_FORMAT),
        };
    });
    return {
        totalIncomeRowData,
        totalExpenseRowData,
        overallTotalIncomeRowData,
    };
};
exports.generateTotalRowData = generateTotalRowData;
const getIncomeExpenseTableStructuredData = (chartData = [], expenseData = [], incomeData = [], timeStep) => {
    const normalizeDate = (dateVal) => {
        if (!dateVal)
            return null;
        return luxon_1.DateTime.isDateTime(dateVal) ? dateVal : luxon_1.DateTime.fromISO(dateVal);
    };
    const formatHeaderLabel = (startDate, endDate) => {
        if (!startDate || !endDate) {
            return '';
        }
        return `${startDate.toFormat(DATE_FORMAT)} - ${endDate.toFormat(DATE_FORMAT)}`;
    };
    const headers = chartData.map((entry) => {
        var _a, _b, _c;
        const periodStartDate = normalizeDate(entry.periodStartDate);
        const periodEndDate = normalizeDate(entry.periodEndDate);
        return ({
            category: entry.category,
            periodStartDate,
            periodEndDate,
            headerLabel: formatHeaderLabel(periodStartDate, periodEndDate),
            quarterLabel: timeStep === 'quarters' && periodEndDate ? periodEndDate.toFormat('M/yyyy') : undefined,
            incomeTotalForReport: (_a = entry.incomeTotalForReport) !== null && _a !== void 0 ? _a : 0,
            spendingTotalForReport: (_b = entry.spendingTotalForReport) !== null && _b !== void 0 ? _b : 0,
            netIncomeTotal: (_c = entry.netIncomeTotal) !== null && _c !== void 0 ? _c : 0,
        });
    });
    const normalizePeriods = (periods = [], isExpenseCategory = false) => headers.map(({ category }) => {
        var _a, _b, _c;
        const matchingPeriod = periods.find((period) => period.category === category);
        return {
            category,
            categoryIds: (_a = matchingPeriod === null || matchingPeriod === void 0 ? void 0 : matchingPeriod.categoryIds) !== null && _a !== void 0 ? _a : [],
            txns: matchingPeriod === null || matchingPeriod === void 0 ? void 0 : matchingPeriod.txns,
            totalOfCategory: (_c = (((_b = matchingPeriod === null || matchingPeriod === void 0 ? void 0 : matchingPeriod.totalOfCategory) !== null && _b !== void 0 ? _b : 0) * (isExpenseCategory ? -1 : 1)).toFixed(2)) !== null && _c !== void 0 ? _c : 0.00,
        };
    });
    const incomeRows = (incomeData || []).map((row) => {
        var _a;
        return (Object.assign(Object.assign(Object.assign({}, row), { groupKey: (0, exports.indentedGroupKey)(row.indentation, row.groupKey), periods: normalizePeriods(row.periods), total: (_a = row.total) !== null && _a !== void 0 ? _a : 0.00 }), (0, exports.normalizeCategoryData)(normalizePeriods(row.periods))));
    });
    const expenseRows = (expenseData || []).map((row) => {
        var _a;
        return (Object.assign(Object.assign(Object.assign({}, row), { groupKey: (0, exports.indentedGroupKey)(row.indentation, row.groupKey), periods: normalizePeriods(row.periods, true), total: (_a = row.total) !== null && _a !== void 0 ? _a : 0.00 }), (0, exports.normalizeCategoryData)(normalizePeriods(row.periods, true))));
    });
    const overallIncome = headers.reduce((sum, header) => sum + header.incomeTotalForReport, 0);
    const overallExpense = headers.reduce((sum, header) => sum + header.spendingTotalForReport, 0);
    const { totalIncomeRowData, totalExpenseRowData, overallTotalIncomeRowData } = (0, exports.generateTotalRowData)(chartData);
    return {
        headers,
        incomeRows,
        expenseRows,
        totals: {
            income: overallIncome,
            expense: overallExpense,
            net: overallIncome + overallExpense,
            totalIncomeRowData,
            totalExpenseRowData,
            overallTotalIncomeRowData,
        },
    };
};
exports.getIncomeExpenseTableStructuredData = getIncomeExpenseTableStructuredData;
const chunkArray = (arrayItems, chunkSize) => {
    if (!(arrayItems === null || arrayItems === void 0 ? void 0 : arrayItems.length))
        return [];
    const chunkedItems = [];
    for (let startIndex = 0; startIndex < arrayItems.length; startIndex += chunkSize) {
        chunkedItems.push(arrayItems.slice(startIndex, startIndex + chunkSize));
    }
    return chunkedItems;
};
const constructPdfReportColumns = (columnHeaders, timeStep, includeOverallTotal, type) => {
    const columns = [
        { header: type === 'category' ? 'Category' : 'Payee', dataKey: 'groupKey' },
    ];
    if (timeStep !== 'none') {
        columnHeaders.forEach(({ headerLabel, category }) => {
            columns.push({ header: headerLabel, dataKey: category });
        });
    }
    if (includeOverallTotal) {
        columns.push({ header: 'Overall Total', dataKey: 'total' });
    }
    return columns;
};
const formatToFixed2 = (value) => {
    if (value === null || value === undefined || value === '')
        return '';
    const raw = typeof value === 'number' ? String(value) : String(value);
    const sanitized = raw.replace(/[^0-9.-]/g, '');
    const numeric = Number(sanitized);
    return Number.isNaN(numeric) ? value : numeric.toFixed(2);
};
const generateReportForPdf = (doc, chartData, expenseData, incomeData, timeStep, type) => {
    var _a;
    const { headers, incomeRows, expenseRows, totals: { income, expense, net, totalIncomeRowData, totalExpenseRowData, overallTotalIncomeRowData }, } = (0, exports.getIncomeExpenseTableStructuredData)(chartData, expenseData, incomeData, timeStep);
    const headerChunks = timeStep === 'none' ? [[]] : chunkArray(headers, MAX_PDF_PERIOD_COLUMNS);
    const reportDataBase = [{
            groupKey: 'Income',
            rowKind: 'section',
        }, ...incomeRows, Object.assign({ groupKey: 'Total Income', total: income === null || income === void 0 ? void 0 : income.toFixed(2), rowKind: 'total' }, totalIncomeRowData), {
            groupKey: 'Expenses',
            rowKind: 'section',
            space: ' ',
        }, ...expenseRows, Object.assign({ groupKey: 'Total Expense', total: (_a = (expense * -1)) === null || _a === void 0 ? void 0 : _a.toFixed(2), rowKind: 'total' }, totalExpenseRowData)];
    const overallTotalRow = Object.assign({ groupKey: 'Overall Total', total: net === null || net === void 0 ? void 0 : net.toFixed(2), rowKind: 'total' }, overallTotalIncomeRowData);
    headerChunks.forEach((headerChunk, index) => {
        doc.addPage();
        const isLastPage = index === headerChunks.length - 1;
        const columns = constructPdfReportColumns(headerChunk, timeStep, isLastPage, type);
        const periodCategories = headerChunk.map(({ category }) => category);
        const reportData = [...reportDataBase, overallTotalRow];
        const tableData = reportData.map((reportRow) => {
            const groupKey = typeof reportRow.groupKey === 'string' && !reportRow.rowKind
                ? reportRow.groupKey.replace(/^-+/, (match) => '    '.repeat(match.length))
                : reportRow.groupKey;
            const flattenedRow = Object.assign(Object.assign({}, reportRow), { groupKey });
            periodCategories.forEach((periodCategory) => {
                var _a, _b;
                const rawValue = (_b = (_a = reportRow === null || reportRow === void 0 ? void 0 : reportRow[periodCategory]) === null || _a === void 0 ? void 0 : _a.totalOfCategory) !== null && _b !== void 0 ? _b : '';
                flattenedRow[periodCategory] = reportRow.groupKey === 'Overall Total'
                    ? formatToFixed2(rawValue)
                    : rawValue;
            });
            if (reportRow.total !== undefined && reportRow.total !== null && reportRow.total !== '') {
                flattenedRow.total = formatToFixed2(reportRow.total);
            }
            return flattenedRow;
        });
        (0, jspdf_autotable_1.autoTable)(doc, {
            theme: 'plain',
            body: tableData,
            columns,
            margin: { top: 110 },
            didDrawPage: () => {
                doc.setFontSize(14);
                doc.text('Report', doc.internal.pageSize.width / 2, 100, { align: 'center' });
            },
            columnStyles: {
                groupKey: { minCellWidth: 160 },
            },
            didParseCell: ({ row, cell }) => {
                const { raw } = row;
                if (row.section === 'body' && (raw === null || raw === void 0 ? void 0 : raw.rowKind)) {
                    cell.styles.lineColor = PDF_COLORS.cellText;
                    cell.styles.lineWidth = { top: 0, bottom: 0, left: 0, right: 0 };
                    if (raw.rowKind === 'section') {
                        cell.styles.fillColor = PDF_COLORS.sectionBackground;
                        cell.styles.fontStyle = 'bold';
                        cell.styles.cellPadding = { top: 6, bottom: 6, left: 4 };
                        cell.styles.lineWidth = { top: 0.1, bottom: 0.1, left: 0, right: 0 };
                    }
                    else if (raw.rowKind === 'total') {
                        cell.styles.fontStyle = 'bold';
                        cell.styles.fillColor = PDF_COLORS.cellBackground;
                        cell.styles.lineWidth = { top: 0.1 };
                        cell.styles.cellPadding = { top: 6, left: 4, bottom: 6 };
                    }
                }
            },
        });
    });
};
const generateTableForPdf = (doc, txns, groupBy, tabName, includeGraph = true) => {
    if (includeGraph) {
        doc.addPage();
    }
    const isNotSpendingTab = (tabName === exports.Tabs.NET_INCOME || tabName === exports.Tabs.INCOME_VS_SPENDING);
    const columns = constructPdfColumns(groupBy, isNotSpendingTab);
    (0, jspdf_autotable_1.autoTable)(doc, {
        theme: 'plain',
        body: txns,
        columns,
        columnStyles: {
            accountName: { cellWidth: isNotSpendingTab ? 175 : 200 },
            payee: { cellWidth: 200 },
            category: { cellWidth: isNotSpendingTab ? 175 : 200 },
            date: { cellWidth: isNotSpendingTab ? 120 : 60 },
            amount: { halign: 'right', cellWidth: 100 },
        },
        headStyles: {
            fillColor: false,
            textColor: PDF_COLORS.cellText,
        },
        didParseCell: ({ row, cell }) => {
            cellStylingForPdfTable(row, cell, tabName);
        },
        didDrawCell: ({ row, cursor, doc: dataDoc, settings }) => {
            // for dashed lines after sub category heads
            const { raw } = row;
            if (row.section === 'body') {
                if (raw.type === 'txn' && raw.isParent) {
                    dataDoc.setLineDashPattern([2, 2], 0);
                    dataDoc.line(settings.margin.left + (raw.level * 20), cursor.y + row.height + 5, dataDoc.internal.pageSize.width - 42, cursor.y + row.height + 5);
                    dataDoc.setLineDashPattern();
                }
            }
        },
        margin: { top: 105 },
    });
};
const setPageHeader = (doc, heading, datePeriod, noTxn, filterText) => {
    const xAxis = doc.internal.pageSize.width / 2;
    doc.setFontSize(14);
    doc.setTextColor(PDF_COLORS.cellText);
    doc.text(heading, xAxis, 40, { align: 'center' });
    doc.setFontSize(12);
    doc.text(datePeriod, xAxis, 60, { align: 'center', lineHeightFactor: 1 });
    doc.text(filterText, xAxis, 80, { align: 'center', lineHeightFactor: 1 });
    if (noTxn) {
        doc.text('No Transactions', xAxis, doc.internal.pageSize.height / 2, { align: 'center', lineHeightFactor: 1 });
    }
};
const setPdfFooter = (doc, pageCurrent, pageCount, dataset) => {
    doc.setFontSize(10);
    doc.setTextColor(PDF_COLORS.mutedText);
    doc.text(`Printed from ${dataset === null || dataset === void 0 ? void 0 : dataset.name} on ${luxon_1.DateTime.now().toFormat('MM/dd/yyyy')}`, 20, doc.internal.pageSize.height - 15);
    doc.text(`Page ${pageCurrent}/${pageCount}`, doc.internal.pageSize.width - 70, doc.internal.pageSize.height - 15);
    doc.setTextColor(PDF_COLORS.cellText);
};
const setPageHeaderAndFooterPdf = (doc, heading, datePeriod, filterText, dataset, noTxn = false) => {
    const pageCount = doc.internal.getNumberOfPages(); // Total Page Number
    for (let count = 0; count <= pageCount; count++) {
        doc.setPage(count);
        const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; // Current Page
        setPageHeader(doc, heading, datePeriod, noTxn, filterText);
        setPdfFooter(doc, pageCurrent, pageCount, dataset);
    }
};
const querySelectAndUpdateLegends = (total) => {
    // Select the container element
    const target = document.querySelector('#pieLegends');
    if (!target) {
        return null;
    }
    const pieLegends = target.cloneNode(true);
    pieLegends.style.display = 'block';
    // Select all button elements within the container
    const legendButtons = pieLegends.querySelectorAll('button');
    // Loop through each button and update the style and content
    legendButtons.forEach((button) => {
        var _a, _b, _c, _d;
        const elemAmount = button.querySelector('#reports_pie_chart_legend_amount');
        if (!elemAmount) {
            return;
        }
        const legentVal = Number((_b = (_a = elemAmount.innerText) === null || _a === void 0 ? void 0 : _a.replaceAll(',', '')) === null || _b === void 0 ? void 0 : _b.replace('$ ', '')) || 0;
        const totalVal = Number((_c = total === null || total === void 0 ? void 0 : total.replaceAll(',', '')) === null || _c === void 0 ? void 0 : _c.replace('$', '')) || 0;
        const percent = ((legentVal / totalVal) * 100).toFixed(2);
        button.innerHTML += `<div style="font-size: 24px; text-align: end; margin-left: 20px; width: 130px;">${percent}%</div>`;
        // Set the max-width and display style
        button.style.maxWidth = 'max-content';
        // Select the color div and update its style
        const colorDiv = button.querySelector('div:nth-child(1)');
        if (colorDiv) {
            colorDiv.style.marginTop = '10px';
        }
        // Select the text wrapper div and update its style
        const textWrapperDiv = button.querySelector('div:nth-child(2)');
        if (textWrapperDiv) {
            textWrapperDiv.style.flexDirection = 'row';
            textWrapperDiv.style.width = '450px';
            // Select the category text element and update its style
            const categoryText = textWrapperDiv.querySelector('p');
            if (categoryText) {
                categoryText.style.fontSize = '24px';
                categoryText.innerText = categoryText.innerText.length > 25 ? `${categoryText.innerText.substring(0, 20)}...` : categoryText.innerText;
            }
            // Select the amount div element and update its style
            const amountWrapper = textWrapperDiv.querySelector('div');
            if (amountWrapper) {
                amountWrapper.style.margin = '0 0 0 auto';
                const amountText = amountWrapper.querySelector('p');
                if (amountText) {
                    amountText.innerText = (_d = amountText.innerText) === null || _d === void 0 ? void 0 : _d.replace('$ ', '$');
                    amountText.style.fontSize = '24px';
                    amountText.style.paddingLeft = '10px';
                }
            }
        }
    });
    // Add a new button for 'Total' if needed
    const totalButton = document.createElement('div');
    totalButton.style.maxWidth = 'max-content';
    totalButton.style.display = 'flex';
    totalButton.style.paddingLeft = '28px';
    totalButton.innerHTML = `
    <div style="display:flex; flex-direction: row; width: 450px; font-size: 24px; font-weight: 500;">
      <p style="margin: 0;">Total</p>
      <p style="margin: 0 0 0 auto; padding-left: 10px;">${total}</p>
    </div>
  `;
    // Append the 'Total' button to the container
    pieLegends.appendChild(totalButton);
    return pieLegends;
};
const categoryTableDSForCsv = (categoryName, txnDate, txnAccount, payeeName, txnAmount, currency) => ([
    categoryName,
    txnDate,
    txnAccount,
    payeeName,
    `"${(0, AmountField_1.formatNumber)(txnAmount, currency, CURRENCY_FORMAT)}"`,
]);
const tableDSForXlsx = (categoryName, txnDate, txnAccount, payeeName, txnAmount, currency) => ({
    Category: categoryName,
    Date: txnDate,
    Account: txnAccount,
    Payee: payeeName,
    Amount: (0, AmountField_1.formatNumber)(txnAmount, currency, CURRENCY_FORMAT),
});
const constructTableDataForTxnsList = (data, tableData, fileType, coaNodesById, currency) => {
    data === null || data === void 0 ? void 0 : data.get('allTxns').sort((first, second) => luxon_1.DateTime.fromISO(second.postedOn).valueOf() - luxon_1.DateTime.fromISO(first.postedOn).valueOf()).forEach((txn, index) => {
        var _a;
        const coaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(txn.coa);
        const txnDate = luxon_1.DateTime.fromISO(txn.postedOn).toFormat('MM/dd/yy');
        const txnAccount = (0, retrievers_1.getAccountString)(txn.accountId);
        const txnCategory = transactions_1.transactionsUtils.isSplitTxn(txn) ? SPLIT_STRING : coaNodesById.get(coaId).name || coaId;
        const txnAmount = (0, AmountField_1.formatNumber)(txn.amount, currency, CURRENCY_FORMAT);
        if (fileType === 'pdf') {
            tableData.push(tableDSForPdf(txn.payee, txnDate, txnAccount, txnCategory, txn.amount, 'txn', true, undefined, undefined, currency));
        }
        else if (fileType === 'csv') {
            tableData.push([
                index + 1,
                `"\t${txnDate}"`,
                txn.payee,
                txnCategory,
                txnAccount,
                `"${txnAmount}"`,
            ]);
        }
        else {
            tableData.push(tableDSForXlsx(txnCategory, txnDate, txnAccount !== null && txnAccount !== void 0 ? txnAccount : '', (_a = txn.payee) !== null && _a !== void 0 ? _a : '', txn.amount, currency !== null && currency !== void 0 ? currency : ''));
        }
    });
};
// eslint-disable-next-line @typescript-eslint/default-param-last
const flatCategoryTreeAndSubTxnsToList = (categoryTree, level = 0, parentGroupKey = '', currency, fileType) => {
    let categoryAndTxnsList = [];
    let itemsWithOthersLabel = [];
    for (const item of categoryTree) { // eslint-disable-line no-restricted-syntax
        let modifiedGroupKey = item === null || item === void 0 ? void 0 : item.groupKey;
        let isGroupKeyEqualsParentGroupKey = false;
        const isParent = item.subgroups.length !== 0;
        if (modifiedGroupKey === parentGroupKey) {
            modifiedGroupKey = `${modifiedGroupKey} (Others)`;
            isGroupKeyEqualsParentGroupKey = true;
        }
        if (categoryTree.length > 1 || (categoryTree.length === 1 && item.subgroups.length > 0)) {
            let categoryOrTxnItem;
            if (fileType === 'pdf') {
                categoryOrTxnItem = tableDSForPdf(modifiedGroupKey, '', '', '', item.total * -1, 'txn', isGroupKeyEqualsParentGroupKey, true, level, currency);
            }
            else if (fileType === 'csv') {
                const categoryName = `${generateHyphens(isGroupKeyEqualsParentGroupKey ? level : level + 1)}${modifiedGroupKey}`;
                categoryOrTxnItem = categoryTableDSForCsv(categoryName, '', '', '', item.total * -1, currency);
            }
            else {
                const categoryName = `${generateHyphens(isGroupKeyEqualsParentGroupKey ? level : level + 1)}${modifiedGroupKey}`;
                categoryOrTxnItem = tableDSForXlsx(categoryName, '', '', '', item.total * -1, currency);
            }
            if (isGroupKeyEqualsParentGroupKey) {
                itemsWithOthersLabel.push(categoryOrTxnItem);
            }
            else {
                categoryAndTxnsList.push(categoryOrTxnItem);
            }
        }
        if (item.subgroups.length > 0) {
            const childItems = flatCategoryTreeAndSubTxnsToList(item.subgroups, level + 1, item === null || item === void 0 ? void 0 : item.groupKey, currency, fileType);
            categoryAndTxnsList = categoryAndTxnsList.concat(childItems.categoryAndTxnsList);
            itemsWithOthersLabel = itemsWithOthersLabel.concat(childItems.itemsWithOthersLabel);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-loop-func
            item.txns.sort((first, second) => luxon_1.DateTime.fromISO(second.postedOn).valueOf() - luxon_1.DateTime.fromISO(first.postedOn).valueOf()).forEach((txn) => {
                let txnAmount = txn === null || txn === void 0 ? void 0 : txn.amount;
                if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
                    const getAmountFromSplit = txn.split.items.find(({ coa }) => coa.id === item.categoryId);
                    if (getAmountFromSplit) {
                        txnAmount = getAmountFromSplit.amount;
                    }
                }
                const txnDate = luxon_1.DateTime.fromISO(txn === null || txn === void 0 ? void 0 : txn.postedOn).toFormat('MM/dd/yyyy');
                const txnAccount = (0, retrievers_1.getAccountString)(txn === null || txn === void 0 ? void 0 : txn.accountId);
                let categoryOrTxnItem;
                if (fileType === 'pdf') {
                    categoryOrTxnItem = tableDSForPdf('', txnDate, txnAccount, (txn === null || txn === void 0 ? void 0 : txn.payee) || '', txnAmount, 'txn', false, isParent, level, currency);
                }
                else if (fileType === 'csv') {
                    categoryOrTxnItem = categoryTableDSForCsv('', txnDate, txnAccount, (txn === null || txn === void 0 ? void 0 : txn.payee) || '', txnAmount, currency);
                }
                else {
                    categoryOrTxnItem = tableDSForXlsx('', txnDate, txnAccount !== null && txnAccount !== void 0 ? txnAccount : '', (txn === null || txn === void 0 ? void 0 : txn.payee) || '', txnAmount, currency !== null && currency !== void 0 ? currency : '');
                }
                if (isGroupKeyEqualsParentGroupKey) {
                    itemsWithOthersLabel.push(categoryOrTxnItem);
                }
                else {
                    categoryAndTxnsList.push(categoryOrTxnItem);
                }
            });
        }
    }
    return { categoryAndTxnsList: categoryAndTxnsList.concat(itemsWithOthersLabel).filter((item) => item), itemsWithOthersLabel: [] };
};
const tableDataForPdf = (data, coaNodesById, groupBy, tabName, currency) => {
    var _a, _b, _c, _d;
    const tableData = [];
    const byPayee = groupBy === 'payee';
    const total = Number(data === null || data === void 0 ? void 0 : data.get('total'));
    const totalRawReport = Number(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'));
    if (groupBy === 'category') {
        tableData.unshift(tableDSForPdf('Expenses', undefined, undefined, undefined, total, 'groupType', true, undefined, 0, currency));
    }
    (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _a === void 0 ? void 0 : _a.spendings) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.subgroups) === null || _d === void 0 ? void 0 : _d.forEach((group) => {
        var _a;
        tableData.push(tableDSForPdf(group.originalKey || (group === null || group === void 0 ? void 0 : group.groupKey), undefined, undefined, undefined, group.total * -1, 'group', true, undefined, 0, currency));
        if (groupBy !== 'category') {
            (_a = group === null || group === void 0 ? void 0 : group.txns) === null || _a === void 0 ? void 0 : _a.sort((first, second) => luxon_1.DateTime.fromISO(second.postedOn).valueOf() - luxon_1.DateTime.fromISO(first.postedOn).valueOf()).forEach((txn) => {
                const coaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(txn.coa);
                let payeeName = txn.payee;
                let levelAssigned = 0;
                if (byPayee && (group === null || group === void 0 ? void 0 : group.groupKey) === 'Everything else') {
                    payeeName = txn.payee;
                    levelAssigned = 1;
                }
                else if (byPayee) {
                    payeeName = null;
                }
                const txnObj = {
                    payee: payeeName,
                    accountName: (0, retrievers_1.getAccountString)(txn.accountId),
                    category: transactions_1.transactionsUtils.isSplitTxn(txn) ? SPLIT_STRING : coaNodesById.get(coaId).name || coaId,
                    date: luxon_1.DateTime.fromISO(txn.postedOn).toFormat('MM/dd/yyyy'),
                    amount: (0, AmountField_1.formatNumber)(txn.amount, currency, CURRENCY_FORMAT),
                    type: 'txn',
                    level: levelAssigned,
                };
                tableData.push(txnObj);
            });
        }
        else {
            const { categoryAndTxnsList } = flatCategoryTreeAndSubTxnsToList(group === null || group === void 0 ? void 0 : group.subgroups, 0, group === null || group === void 0 ? void 0 : group.groupKey, currency, 'pdf');
            tableData.push(...categoryAndTxnsList);
        }
    });
    if (tabName === exports.Tabs.NET_INCOME || tabName === exports.Tabs.INCOME_VS_SPENDING) {
        constructTableDataForTxnsList(data, tableData, 'pdf', coaNodesById, currency);
    }
    if (tabName !== exports.Tabs.NET_INCOME && tabName !== exports.Tabs.INCOME_VS_SPENDING) {
        tableData.push(tableDSForPdf('OVERALL TOTAL', undefined, undefined, undefined, total, 'total', true, undefined, 0, currency));
    }
    if (tabName === exports.Tabs.NET_INCOME) {
        tableData.push(tableDSForPdf('', 'OVERALL NET INCOME', undefined, undefined, total, 'total', true, undefined, 0, currency));
    }
    else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
        tableData.push(tableDSForPdf('', 'TOTAL INCOME', undefined, undefined, total - totalRawReport, 'total', true, undefined, 0, currency), tableDSForPdf('', 'TOTAL EXPENSE', undefined, undefined, totalRawReport, 'total', true, undefined, 0, currency), tableDSForPdf('', 'OVERALL NET INCOME', undefined, undefined, total, 'total', true, undefined, 0, currency));
    }
    return tableData;
};
const generateFilterText = (filter) => {
    var _a, _b, _c, _d;
    let filterText = 'All Accounts, All Categories, All Tags, All Payees';
    if (filter) {
        filterText = 'accountCount Accounts, categoriesCount Categories, tagsCount Tags, payeesCount Payees';
        filterText = filterText.replace('accountCount', ((_a = filter === null || filter === void 0 ? void 0 : filter.accounts) === null || _a === void 0 ? void 0 : _a.size) ? filter.accounts.size : 'All');
        filterText = filterText.replace('categoriesCount', ((_b = filter === null || filter === void 0 ? void 0 : filter.categories) === null || _b === void 0 ? void 0 : _b.size) ? filter.categories.size : 'All');
        filterText = filterText.replace('tagsCount', ((_c = filter === null || filter === void 0 ? void 0 : filter.tags) === null || _c === void 0 ? void 0 : _c.size) ? filter.tags.size : 'All');
        filterText = filterText.replace('payeesCount', ((_d = filter === null || filter === void 0 ? void 0 : filter.payees) === null || _d === void 0 ? void 0 : _d.size) ? filter.payees.size : 'All');
    }
    return filterText;
};
exports.generateFilterText = generateFilterText;
const generatePdf = ({ data, chartType, graphRef, coaNodesById, currency, dateRange, tabName, groupBy, filter, dataset, cb, chartData, expenseData, incomeData, timeStep, breakdownIncomeVsExpense, includeReport, includeGraph }) => {
    var _a, _b, _c;
    const datePeriod = `${luxon_1.DateTime.fromISO((_a = dateRange === null || dateRange === void 0 ? void 0 : dateRange.value) === null || _a === void 0 ? void 0 : _a.s).toFormat('MM/dd/yyyy')} through ${luxon_1.DateTime.fromISO((_b = dateRange === null || dateRange === void 0 ? void 0 : dateRange.value) === null || _b === void 0 ? void 0 : _b.e).toFormat('MM/dd/yyyy')}`;
    let heading = '';
    const total = (0, AmountField_1.formatNumber)(Number(data === null || data === void 0 ? void 0 : data.get('total')) * (tabName === exports.Tabs.SPENDING ? -1 : 1), currency, CURRENCY_FORMAT);
    if (tabName === exports.Tabs.SPENDING) {
        heading += `${(0, utils_1.capitalize)(tabName)} by ${(0, utils_1.capitalize)(groupBy)} - ${dateRange === null || dateRange === void 0 ? void 0 : dateRange.label}`;
    }
    else if (tabName === exports.Tabs.NET_INCOME) {
        heading += `Net Income - ${dateRange === null || dateRange === void 0 ? void 0 : dateRange.label}`;
    }
    else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
        heading += `Income vs Expense - ${dateRange === null || dateRange === void 0 ? void 0 : dateRange.label}`;
    }
    const filterText = (0, exports.generateFilterText)(filter);
    if ((data === null || data === void 0 ? void 0 : data.get('allTxns').size) === 0 && (data === null || data === void 0 ? void 0 : data.get('total')) === 0) {
        const doc = new jspdf_1.jsPDF('l', 'pt', 'a4'); // eslint-disable-line new-cap
        setPageHeaderAndFooterPdf(doc, heading, datePeriod, filterText, dataset, true);
        doc.save(`${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.pdf`);
        cb();
        return;
    }
    const tableContents = tableDataForPdf(data, coaNodesById, groupBy, tabName, currency);
    const graphImage = includeGraph ? (_c = graphRef === null || graphRef === void 0 ? void 0 : graphRef.current) === null || _c === void 0 ? void 0 : _c.getGraphImage() : null;
    if (graphImage) {
        graphImage.then((graphImg) => {
            const doc = new jspdf_1.jsPDF('l', 'pt', 'a4'); // eslint-disable-line new-cap
            const xAxis = doc.internal.pageSize.width / 2;
            doc.setFontSize(14);
            if (tabName === exports.Tabs.NET_INCOME) {
                doc.text(`Overall Net Income: ${total}`, xAxis, 110, { align: 'center' });
            }
            else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
                doc.text(`Overall Net Income: ${total}`, xAxis, 110, { align: 'center' });
                doc.setFontSize(12);
                doc.text(`Total Income: ${(0, AmountField_1.formatNumber)(Number(data === null || data === void 0 ? void 0 : data.get('total')) - Number(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total')), currency, CURRENCY_FORMAT)} | Total Expense: ${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'), currency, CURRENCY_FORMAT)}`, xAxis, 130, { align: 'center' });
            }
            doc.setFontSize(12);
            if (chartType === exports.ChartTypes.PIE) {
                const graphContents = querySelectAndUpdateLegends(total);
                generateTableForPdf(doc, tableContents, groupBy, tabName, includeGraph);
                if (graphContents) {
                    doc.html(graphContents, {
                        callback: (document) => {
                            document.addImage(graphImg, 'PNG', 80, 120, 350, 350);
                            setPageHeaderAndFooterPdf(document, heading, datePeriod, filterText, dataset, palette, false);
                            document.save(`${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.pdf`);
                            cb();
                        },
                        x: 450,
                        y: 170,
                        width: 400,
                        windowWidth: 850,
                    });
                }
            }
            else {
                doc.addImage(graphImg, 'PNG', 120, 160, 600, 0);
                if (includeReport && tabName === exports.Tabs.INCOME_VS_SPENDING && breakdownIncomeVsExpense.id !== 'none') {
                    generateReportForPdf(doc, chartData, expenseData, incomeData, timeStep, breakdownIncomeVsExpense.id);
                }
                generateTableForPdf(doc, tableContents, groupBy, tabName, includeGraph);
                setPageHeaderAndFooterPdf(doc, heading, datePeriod, filterText, dataset, false);
                doc.save(`${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.pdf`);
                cb();
            }
        });
    }
    else {
        const doc = new jspdf_1.jsPDF('l', 'pt', 'a4'); // eslint-disable-line new-cap
        const xAxis = doc.internal.pageSize.width / 2;
        doc.setFontSize(14);
        if (tabName === exports.Tabs.NET_INCOME) {
            doc.text(`Overall Net Income: ${total}`, xAxis, 110, { align: 'center' });
        }
        else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
            doc.text(`Overall Net Income: ${total}`, xAxis, 110, { align: 'center' });
            doc.setFontSize(12);
            doc.text(`Total Income: ${(0, AmountField_1.formatNumber)(Number(data === null || data === void 0 ? void 0 : data.get('total')) - Number(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total')), currency, CURRENCY_FORMAT)} | Total Expense: ${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'), currency, CURRENCY_FORMAT)}`, xAxis, 130, { align: 'center' });
        }
        doc.setFontSize(12);
        if (includeReport && tabName === exports.Tabs.INCOME_VS_SPENDING && breakdownIncomeVsExpense.id !== 'none') {
            generateReportForPdf(doc, chartData, expenseData, incomeData, timeStep, breakdownIncomeVsExpense.id);
            doc.addPage();
        }
        generateTableForPdf(doc, tableContents, groupBy, tabName, includeGraph);
        setPageHeaderAndFooterPdf(doc, heading, datePeriod, filterText, dataset, false);
        doc.save(`${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.pdf`);
        cb();
    }
};
exports.downloadableFileTypes = {
    csv: 'csv',
    xlsx: 'xlsx',
    pdf: 'pdf',
};
const getDownloadFormats = () => {
    const arrOptions = [
        {
            label: 'Excel (.xlsx)',
            value: exports.downloadableFileTypes.xlsx,
            id: exports.downloadableFileTypes.xlsx,
        },
        {
            label: 'CSV (.csv)',
            value: exports.downloadableFileTypes.csv,
            id: exports.downloadableFileTypes.csv,
        },
        {
            label: 'PDF (.pdf)',
            value: exports.downloadableFileTypes.pdf,
            id: exports.downloadableFileTypes.pdf,
        },
    ];
    return arrOptions;
};
exports.getDownloadFormats = getDownloadFormats;
const generateTableData = (data, coaNodesById, tabName, groupBy, currency, fileType) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const tableData = [];
    if (tabName === exports.Tabs.SPENDING && groupBy !== 'none') {
        const total = (0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('total'), currency, CURRENCY_FORMAT);
        if (groupBy === 'payee') {
            if (fileType === 'csv') {
                tableData.push(['Payee', 'Date', 'Account', 'Category', 'Amount']);
            }
            (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _a === void 0 ? void 0 : _a.spendings) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.subgroups) === null || _d === void 0 ? void 0 : _d.forEach((group) => {
                var _a;
                if (fileType === 'csv') {
                    tableData.push([group.originalKey || (group === null || group === void 0 ? void 0 : group.groupKey), '', '', '', `"${(0, AmountField_1.formatNumber)(group.total * -1, currency, CURRENCY_FORMAT)}"`]);
                }
                else {
                    tableData.push({
                        Payee: group.originalKey || (group === null || group === void 0 ? void 0 : group.groupKey),
                        Date: '',
                        Account: '',
                        Category: '',
                        Amount: (0, AmountField_1.formatNumber)(group.total * -1, currency, CURRENCY_FORMAT),
                    });
                }
                (_a = group === null || group === void 0 ? void 0 : group.txns) === null || _a === void 0 ? void 0 : _a.sort((first, second) => luxon_1.DateTime.fromISO(second.postedOn).valueOf() - luxon_1.DateTime.fromISO(first.postedOn).valueOf()).forEach((txn) => {
                    const coaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(txn.coa);
                    const txnDate = luxon_1.DateTime.fromISO(txn.postedOn).toFormat('MM/dd/yyyy');
                    const txnAccount = (0, retrievers_1.getAccountString)(txn.accountId);
                    const txnCategory = transactions_1.transactionsUtils.isSplitTxn(txn) ? SPLIT_STRING : coaNodesById.get(coaId).name || coaId;
                    const txnAmount = (0, AmountField_1.formatNumber)(txn.amount, currency, CURRENCY_FORMAT);
                    if (fileType === 'csv') {
                        tableData.push([
                            (group === null || group === void 0 ? void 0 : group.groupKey) === 'Everything else' ? `-${txn.payee}` : '',
                            txnDate,
                            txnAccount,
                            txnCategory,
                            `"${txnAmount}"`
                        ]);
                    }
                    else {
                        tableData.push({
                            Payee: (group === null || group === void 0 ? void 0 : group.groupKey) === 'Everything else' ? `-${txn.payee}` : '',
                            Date: txnDate,
                            Account: txnAccount !== null && txnAccount !== void 0 ? txnAccount : '',
                            Category: txnCategory,
                            Amount: txnAmount,
                        });
                    }
                });
            });
        }
        else if (groupBy === 'category') {
            if (fileType === 'csv') {
                tableData.push(['Category', 'Date', 'Account', 'Payee', 'Amount'], ['Expenses', '', '', '', `"${total}"`]);
            }
            else {
                tableData.push(tableDSForXlsx('Expenses', '', '', '', data === null || data === void 0 ? void 0 : data.get('total'), currency));
            }
            (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _e === void 0 ? void 0 : _e.spendings) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.subgroups) === null || _h === void 0 ? void 0 : _h.forEach((group) => {
                if (fileType === 'csv') {
                    tableData.push([group === null || group === void 0 ? void 0 : group.groupKey, '', '', '', `"${(0, AmountField_1.formatNumber)(group.total * -1, currency, CURRENCY_FORMAT)}"`]);
                }
                else {
                    tableData.push(tableDSForXlsx(group === null || group === void 0 ? void 0 : group.groupKey, '', '', '', group.total * -1, currency));
                }
                const { categoryAndTxnsList } = flatCategoryTreeAndSubTxnsToList(group === null || group === void 0 ? void 0 : group.subgroups, 0, group === null || group === void 0 ? void 0 : group.groupKey, currency, fileType);
                tableData.push(...categoryAndTxnsList);
            });
        }
        if (fileType === 'csv') {
            tableData.push(['OVERALL TOTAL', '', '', '', `"${total}"`]);
        }
        else {
            tableData.push({
                [groupBy === 'category' ? 'Category' : 'Payee']: 'OVERALL TOTAL',
                Date: '',
                Account: '',
                [groupBy === 'category' ? 'Payee' : 'Category']: '',
                Amount: total,
            });
        }
    }
    else {
        if (fileType === 'csv') {
            tableData.push(['Id', 'Date', 'Payee', 'Category', 'Account', 'Amount']);
        }
        constructTableDataForTxnsList(data, tableData, fileType, coaNodesById, currency);
        if (tabName === exports.Tabs.NET_INCOME) {
            if (fileType === 'csv') {
                tableData.push(['', 'OVERALL NET INCOME', '', '', '', `"${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('total'), currency, CURRENCY_FORMAT)}"`]);
            }
            else {
                tableData.push(tableDSForXlsx('', 'OVERALL NET INCOME', '', '', data === null || data === void 0 ? void 0 : data.get('total'), currency));
            }
        }
        else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
            const totalDifference = Number(data === null || data === void 0 ? void 0 : data.get('total')) - Number(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'));
            if (fileType === 'csv') {
                tableData.push(['', 'TOTAL INCOME', '', '', '', `"${(0, AmountField_1.formatNumber)(totalDifference, currency, CURRENCY_FORMAT)}"`]);
                tableData.push(['', 'TOTAL EXPENSE', '', '', '', `"${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'), currency, CURRENCY_FORMAT)}"`]);
                tableData.push(['', 'OVERALL NET INCOME', '', '', '', `"${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('total'), currency, CURRENCY_FORMAT)}"`]);
            }
            else {
                tableData.push(tableDSForXlsx('', 'TOTAL INCOME', '', '', totalDifference, currency), tableDSForXlsx('', 'TOTAL EXPENSE', '', '', data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'), currency), tableDSForXlsx('', 'OVERALL NET INCOME', '', '', data === null || data === void 0 ? void 0 : data.get('total'), currency));
            }
        }
        if (groupBy === 'none') {
            const total = (0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('total'), currency, CURRENCY_FORMAT);
            if (fileType === 'csv') {
                tableData.push(['', 'OVERALL TOTAL', '', '', '', `"${total}"`]);
            }
            else {
                tableData.push(tableDSForXlsx('', 'OVERALL TOTAL', '', '', data === null || data === void 0 ? void 0 : data.get('total'), currency));
            }
        }
    }
    return tableData;
};
const csvCellNumberFormatter = (value) => {
    let inputValue;
    if (typeof value === 'number') {
        inputValue = value;
    }
    else {
        inputValue = Number(value.replace(/,/g, ''));
    }
    const formattedNumber = Number.isNaN(inputValue) ? '0.00' : inputValue.toFixed(2);
    // \t forces Excel to keep text formatting
    return `"\t${formattedNumber}"`;
};
const generateReportDataForCsv = ({ chartData, expenseData, incomeData, timeStep, type }) => {
    const { headers, incomeRows, expenseRows, totals: { income, expense, net, totalIncomeRowData, totalExpenseRowData, overallTotalIncomeRowData }, } = (0, exports.getIncomeExpenseTableStructuredData)(chartData, expenseData, incomeData, timeStep);
    const reportTable = [[], [DASH_STRING, 'REPORT', DASH_STRING], [], []]; // Empty array added for separating transactions and report
    const reportHeader = [type === 'category' ? 'Category' : 'Payee'];
    if (timeStep !== 'none') {
        headers.forEach(({ headerLabel }) => {
            reportHeader.push(headerLabel);
        });
    }
    reportHeader.push('Overall Total');
    const reportData = [['Income']];
    incomeRows.forEach((incomeRowData) => {
        const incomeRow = [`="${incomeRowData.groupKey}"`]; // added =" " for csv-safe formula wrapping  
        if (timeStep !== 'none') {
            headers.forEach(({ category }) => {
                incomeRow.push(csvCellNumberFormatter(incomeRowData[category].totalOfCategory));
            });
        }
        incomeRow.push(csvCellNumberFormatter(incomeRowData.total));
        reportData.push(incomeRow);
    });
    const incomeTotalRow = ['Total Income'];
    if (timeStep !== 'none') {
        headers.forEach(({ category }) => {
            incomeTotalRow.push(csvCellNumberFormatter(totalIncomeRowData[category].totalOfCategory));
        });
    }
    incomeTotalRow.push(csvCellNumberFormatter(income));
    reportData.push(incomeTotalRow);
    reportData.push(['Expenses']);
    expenseRows.forEach((expenseRowData) => {
        const expenseRow = [`="${expenseRowData.groupKey}"`]; // added =" " for csv-safe formula wrapping
        if (timeStep !== 'none') {
            headers.forEach(({ category }) => {
                expenseRow.push(csvCellNumberFormatter(expenseRowData[category].totalOfCategory));
            });
        }
        expenseRow.push(csvCellNumberFormatter(expenseRowData.total));
        reportData.push(expenseRow);
    });
    const expenseTotalRow = ['Total Expenses'];
    if (timeStep !== 'none') {
        headers.forEach(({ category }) => {
            expenseTotalRow.push(csvCellNumberFormatter(totalExpenseRowData[category].totalOfCategory));
        });
    }
    expenseTotalRow.push(csvCellNumberFormatter(expense * -1));
    reportData.push(expenseTotalRow);
    const overallTotalRow = ['Overall Total'];
    if (timeStep !== 'none') {
        headers.forEach(({ category }) => {
            overallTotalRow.push(csvCellNumberFormatter(overallTotalIncomeRowData[category].totalOfCategory));
        });
    }
    overallTotalRow.push(csvCellNumberFormatter(net));
    reportData.push(overallTotalRow);
    reportTable.push(reportHeader);
    reportTable.push(...reportData);
    return reportTable;
};
const generateCsv = ({ data, coaNodesById, tabName, groupBy, currency, dataset, cb, chartData, expenseData, incomeData, timeStep, breakdownIncomeVsExpense, includeReport }) => {
    const tableData = [];
    if (includeReport && tabName === exports.Tabs.INCOME_VS_SPENDING && breakdownIncomeVsExpense.id !== 'none') {
        const reportTableData = generateReportDataForCsv({ chartData, expenseData, incomeData, timeStep, type: breakdownIncomeVsExpense.id });
        tableData.push(...reportTableData);
        tableData.push([]);
    }
    tableData.push([], [DASH_STRING, 'Transactions', DASH_STRING], [], []);
    const csvData = generateTableData(data, coaNodesById, tabName, groupBy, currency, 'csv');
    tableData.push(...csvData);
    const csvContent = `data:text/csv;charset=utf-8, ${tableData.map((e) => e.join(',')).join('\n')}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.csv`);
    document.body.appendChild(link);
    link.click();
    cb();
};
const generateXlsx = ({ data, coaNodesById, tabName, groupBy, currency, dataset, cb, chartData, expenseData, incomeData, breakdownIncomeVsExpense, timeStep, includeReport }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const tableData = generateTableData(data, coaNodesById, tabName, groupBy, currency, 'xlsx');
    const schema = [];
    let schemaOrder = [];
    if (tabName === exports.Tabs.SPENDING && groupBy !== 'none') {
        if (groupBy === 'category') {
            schemaOrder = ['Category', 'Date', 'Account', 'Payee', 'Amount'];
        }
        else {
            schemaOrder = ['Payee', 'Date', 'Account', 'Category', 'Amount'];
        }
    }
    else {
        schemaOrder = ['Date', 'Payee', 'Category', 'Account', 'Amount'];
    }
    schemaOrder.forEach((header) => {
        schema.push({
            column: header,
            type: String,
            value: (val) => val[header],
            align: header === 'Amount' ? 'right' : 'left',
        });
    });
    const reportSchema = [];
    const xlData = [tableData];
    const schemas = [schema];
    const sheets = ['Transactions']; // Sheet name
    if (includeReport && tabName === exports.Tabs.INCOME_VS_SPENDING && breakdownIncomeVsExpense.id !== 'none') {
        const { headers, incomeRows, expenseRows, totals: { income, expense, net, totalIncomeRowData, totalExpenseRowData, overallTotalIncomeRowData }, } = (0, exports.getIncomeExpenseTableStructuredData)(chartData, expenseData, incomeData, timeStep);
        reportSchema.push({
            column: breakdownIncomeVsExpense.id === 'category' ? 'Category' : 'Payee',
            type: String,
            value: (val) => val.groupKey,
        });
        if (timeStep !== 'none') {
            headers.forEach(({ headerLabel, category }) => {
                reportSchema.push({
                    column: headerLabel,
                    value: (val) => { var _a; return ((_a = val[category]) === null || _a === void 0 ? void 0 : _a.totalOfCategory) || (val === null || val === void 0 ? void 0 : val.space) || 0.00; },
                    align: 'right',
                });
            });
        }
        reportSchema.push({
            column: 'Overall Total',
            value: (val) => val.total ? (0, AmountField_1.formatNumber)(val.total, '', CURRENCY_FORMAT) : '',
            align: 'right',
        });
        const reportData = [{
                groupKey: 'Income',
                space: ' ',
            }, ...incomeRows, Object.assign({ groupKey: 'Total Income', total: income === null || income === void 0 ? void 0 : income.toFixed(2) }, totalIncomeRowData), {
                groupKey: 'Expenses',
                space: ' ',
            }, ...expenseRows, Object.assign({ groupKey: 'Total Expense', total: (_a = (expense * -1)) === null || _a === void 0 ? void 0 : _a.toFixed(2) }, totalExpenseRowData), Object.assign({ groupKey: 'Overall Total', total: net === null || net === void 0 ? void 0 : net.toFixed(2) }, overallTotalIncomeRowData)];
        xlData.push(reportData);
        schemas.push(reportSchema);
        sheets.push('Report');
    }
    yield write_excel_file_1.default(xlData, {
        schema: schemas,
        sheets,
        fileName: `${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.xlsx`,
    });
    cb();
});
const generateDownloadFile = (objParams) => ({
    [exports.downloadableFileTypes.pdf]: () => generatePdf(Object.assign({}, objParams)),
    [exports.downloadableFileTypes.csv]: () => generateCsv(Object.assign({}, objParams)),
    [exports.downloadableFileTypes.xlsx]: () => generateXlsx(Object.assign({}, objParams)),
});
exports.generateDownloadFile = generateDownloadFile;
exports.IncomeVsExpenseBreakdownTypes = [
    { id: 'none', label: 'None' },
    { id: 'category', label: 'Category' },
    { id: 'payee', label: 'Payee' },
];
exports.IntervalFilterOptions = [
    { label: 'Monthly', value: 'months', id: 'monthly' },
    { label: 'Quarterly', value: 'quarters', id: 'quarterly' },
];
exports.isOverTimeOptions = [
    { label: 'Total', value: 'total', id: 'total_total' },
    { label: 'Over time', value: 'over-time', id: 'total_over_time' },
];
const checkIfSelectedCategoryEquals = (selectedCategory, compareWithCategory) => selectedCategory === compareWithCategory;
exports.checkIfSelectedCategoryEquals = checkIfSelectedCategoryEquals;
const checkIfSelectedReportTableCellEquals = (selectedCell, categoryId, category, section) => selectedCell === `${categoryId}-${category}`
    || (section ? selectedCell === `${section}-${categoryId}-${category}` : false);
exports.checkIfSelectedReportTableCellEquals = checkIfSelectedReportTableCellEquals;
const getTimestepLabel = (timeStep, date, isLastIndex, periodEndDate) => {
    let endDate = date.plus({ month: 2 });
    if (isLastIndex && periodEndDate && timeStep === 'quarters') {
        endDate = periodEndDate;
    }
    const yearWithOrWithoutMonth = timeStep === 'years' ? 'yyyy' : 'LLL yy';
    return timeStep !== 'quarters'
        ? date.toFormat(timeStep === 'days' ? 'd' : yearWithOrWithoutMonth)
        : `${date.toFormat('LLL')} - ${endDate.toFormat('LLL')} (${date.toFormat('yyyy')})`;
};
exports.getTimestepLabel = getTimestepLabel;
exports.VISIBLE_SECTIONS = {
    graph: 'graph',
    report: 'report',
};
const getSectionValueForTracking = (selectedBreakdownId, visibleSection, forSection) => selectedBreakdownId === exports.IncomeVsExpenseBreakdownTypes[0].id ? 'null' : visibleSection === forSection;
exports.getSectionValueForTracking = getSectionValueForTracking;
